<template>
  <v-container density="compact" dense="true">
    <h1>Membership Options</h1>
    <v-row justify="start">
      <v-col v-for="membershipType in membershipsFiltered">
        <MembershipTypeCard :membership-type="membershipType" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { useMembershipPurchaseOptions } from "@/composables/shop/useMembershipPurchaseOptions";
const membershipsFiltered = useMembershipPurchaseOptions(3);
//const membershipTypeName = appData.membershipTypes
//const membershipTypeDescription = appData.membershipTypeDiscounts
</script>
